import React from 'react'

const ControlDisponibilidadContainer = () => (
    <>
      <iframe
        title="Disponilidad Consolidado"
        width="100%"
        height="90%"
        src="https://app.powerbi.com/reportEmbed?reportId=9b28085c-05c4-444c-b28d-57b511ba97fd&autoAuth=true&ctid=1a8e863a-6a66-4905-990b-f7062b267787"
        frameBorder="0"
        allowFullScreen="true"
      />
      
    </>
  )

export default ControlDisponibilidadContainer
